import { connect } from "react-redux";
import * as Redux from "redux";
import FullscreenView, { FullscreenViewProps } from "./component";
import { selectedFlyer, isMerchantUSBased } from "../../selectors";

const mapStateToProps = (state: any, props: any): FullscreenViewProps => {
  return {
    metric: state.analytics.metrics_container_tab,
    metricData: state.analytics_metric.metric_data,
    metricDataLoading: state.analytics_metric.metric_data_loading,
    flyer: selectedFlyer(state, props),
    flyerLoading: state.analytics_metric.flyersLoading,
    flyerItems: state.analytics_metric.flyerItems,
    flyerItemsLoading: state.analytics_metric.flyer_items_loading,
    view: state.analytics_metric.view,
    groupBy: state.analytics_metric.group_by,
    compareBy: state.analytics_metric.compare_by,
    usBased: isMerchantUSBased(state, props),
    onClose: props.onClose
  };
};

export default connect(mapStateToProps, {})(FullscreenView);



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/FullscreenView/container.ts